(() => {
  // Opening one question closes the others in the same list
  function closeOthers(trigger) {
    trigger.closest('.mch-faqs').querySelectorAll('.mch-faqs__trigger').forEach((other) => {
      if (other !== trigger) setOpen(other, false);
    });
  }

  function setOpen(trigger, open) {
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Delegated so it keeps working after the theme editor re-renders the section
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.mch-faqs__trigger');
    if (!trigger) return;
    const open = trigger.getAttribute('aria-expanded') !== 'true';
    if (open) closeOthers(trigger);
    setOpen(trigger, open);
  });

  // Theme editor: open the question when its block is selected in the sidebar
  document.addEventListener('shopify:block:select', (e) => {
    const trigger = e.target.querySelector('.mch-faqs__trigger');
    if (trigger) {
      closeOthers(trigger);
      setOpen(trigger, true);
    }
  });
})();
